<div
  (click)="navigateToDetails()"
  class="group relative flex h-full flex-col overflow-hidden rounded-xl border border-gray-200 bg-white transition-all hover:cursor-pointer hover:shadow-lg"
  [class.opacity-60]="isOutOfStock()">
  <div class="relative flex h-48 w-full items-center justify-center bg-gray-50">
    @if (isOutOfStock()) {
      <div
        class="absolute top-0 z-10 rounded-xl bg-red-600 px-2 py-1 ltr:left-0 ltr:rounded-tr-none ltr:rounded-bl-none rtl:right-0 rtl:rounded-tl-none rtl:rounded-br-none">
        <span class="text-xs font-semibold text-white" i18n="@@outOfStock">Out of Stock</span>
      </div>
    } @else if (offerDiscount()) {
      <div
        class="bgTabsColor absolute top-0 z-10 rounded-xl px-2 py-1 ltr:left-0 ltr:rounded-tr-none ltr:rounded-bl-none rtl:right-0 rtl:rounded-tl-none rtl:rounded-br-none">
        <span class="text-xs font-semibold text-white">
          <span>{{ isArabic() ? "خصم إضافي" : "Extra Discount" }}</span>
          {{ offerDiscount()?.discountValue }}%
        </span>
      </div>
    }

    @if (remainingQuantity() != null) {
      <div class="absolute start-3 z-10" [class.top-3]="!hasCornerTag()" [class.top-9]="hasCornerTag()">
        @if (isLimitReached()) {
          <span
            class="inline-flex items-center gap-1.5 rounded-full border border-red-200 bg-red-50 px-2.5 py-1 text-xs font-semibold whitespace-nowrap text-red-700">
            <app-limit-reached-icon size="14" />
            {{ isArabic() ? "تم الوصول للحد المسموح" : "Limit Reached" }}
          </span>
        } @else {
          <span
            class="inline-flex items-center gap-1.5 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-xs font-semibold whitespace-nowrap text-amber-800">
            <app-remaining-quantity-icon size="14" />
            {{ isArabic() ? "متبقي " + remainingQuantity() : remainingQuantity() + " Remaining" }}
          </span>
        }
      </div>
    }

    @if (variant() === "list") {
      <div
        class="absolute top-4 z-10 flex flex-col gap-2 opacity-0 transition-opacity duration-300 group-hover:opacity-100 ltr:right-4 rtl:left-4">
        <button
          (click)="onAddToWishlist($event)"
          class="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-white text-gray-500 shadow-sm transition-all hover:scale-110 hover:textTabsColor active:scale-95">
          <app-add-wishlist-icon />
        </button>

        <button
          (click)="onActivePopup($event)"
          [disabled]="isOutOfStock() || isPharmacySuspended() || isLimitReached()"
          class="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-white text-gray-500 shadow-sm transition-all hover:scale-110 hover:textTabsColor active:scale-95 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:scale-100 disabled:hover:text-gray-500">
          <app-add-cart-icon />
        </button>
      </div>
    }

    <img
      [src]="imagePreview()"
      [alt]="isArabic() ? product().titleAr : product().titleEn"
      class="h-3/4 w-3/4 object-contain transition-transform group-hover:scale-105" />
  </div>

  <div class="flex flex-1 flex-col px-6 py-4">
    <h3
      class="line-clamp-2 h-12 font-['Inter'] text-base font-medium text-gray-900"
      [title]="isArabic() ? product().titleAr : product().titleEn">
      {{ isArabic() ? product().titleAr : product().titleEn }}
    </h3>

    @if (mfgCompany()) {
      <div class="mt-1 flex items-center justify-between text-xs text-gray-500">
        <p>
          {{ isArabic() ? mfgCompany()?.titleAr : mfgCompany()?.titleEn }}
        </p>
      </div>
    }

    <div class="my-4 h-px w-full bg-gray-200"></div>

    <div class="grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center">
      @if (product().businessPrice) {
        <div class="flex min-w-0 items-start gap-2">
          <app-business-price-icon size="24" />

          <div class="min-w-0">
            @if (offerDiscount()) {
              <div class="flex flex-wrap items-baseline gap-x-1.5 gap-y-0.5">
                <span class="text-[11px] whitespace-nowrap text-gray-400 line-through">
                  {{ product().businessPrice }}
                  <span class="text-[10px] font-medium text-gray-900">
                    {{ isArabic() ? "ج.م" : "EGP" }}
                  </span>
                </span>

                @if (businessPriceDiscountPercentage()) {
                  <span class="text-[11px] font-semibold whitespace-nowrap text-green-600">
                    ({{ businessPriceDiscountPercentage() }}%)
                  </span>
                }
              </div>

              <div class="flex flex-wrap items-baseline gap-x-1.5 gap-y-0.5">
                <span class="text-sm font-bold whitespace-nowrap text-gray-900">
                  {{ discountedBusinessPrice() }}
                  <span class="text-xs font-medium text-gray-900">
                    {{ isArabic() ? "ج.م" : "EGP" }}
                  </span>
                </span>

                <span class="text-[11px] font-semibold whitespace-nowrap text-green-600">
                  ({{ offerDiscount()?.discountValue }}%)
                </span>
              </div>
            } @else {
              <div class="flex flex-wrap items-baseline gap-x-1.5 gap-y-0.5">
                <span class="text-sm font-bold whitespace-nowrap text-gray-900">
                  {{ businessPrice() }}
                  <span class="text-xs font-medium text-gray-900">
                    {{ isArabic() ? "ج.م" : "EGP" }}
                  </span>
                </span>

                @if (businessPriceDiscountPercentage()) {
                  <span class="text-[11px] font-semibold whitespace-nowrap text-green-600">
                    ({{ businessPriceDiscountPercentage() }}%)
                  </span>
                }
              </div>
            }
          </div>
        </div>
      }

      <div class="mx-auto h-8 border-s"></div>

      @if (product().customerPrice) {
        <div class="flex min-w-0 items-center justify-start gap-2 ps-3">
          <app-customer-price-icon size="24" />

          <span class="text-sm font-bold whitespace-nowrap text-gray-900">
            {{ product().customerPrice }}
            <span class="text-xs font-medium text-gray-900">
              {{ isArabic() ? "ج.م" : "EGP" }}
            </span>
          </span>
        </div>
      }
    </div>

    <div class="mt-auto">
      @if (product().mfgDate || product().expDate || product().batchNumber) {
        <div class="mt-2 grid grid-cols-[1fr_auto_1fr] items-center pt-2 text-sm font-medium text-gray-900">
          @if (product().mfgDate && product().expDate) {
            <div class="flex items-center gap-1.5">
              <app-mfg-exp-dates-icon size="18" />

              <span class="truncate">
                {{ product().mfgDate | date: "yy" }}-{{ product().mfgDate | date: "MM" }}-{{
                  product().expDate | date: "yy"
                }}
              </span>
            </div>
          } @else if (product().expDate) {
            <div class="flex items-center gap-1.5">
              <app-mfg-exp-dates-icon size="18" />

              <span class="truncate">
                {{ product().expDate | date: "MM/yy" }}
              </span>
            </div>
          }

          <div class="mx-auto h-8 border-s"></div>

          @if (product().batchNumber) {
            <div class="flex min-w-0 items-center justify-start gap-1.5 ps-3">
              <app-batch-number-icon size="18" />

              <span class="min-w-0 truncate" [title]="product().batchNumber">
                {{ product().batchNumber }}
              </span>
            </div>
          }
        </div>
      }

      @if (variant() === "bundle") {
        <div class="mt-3 flex items-center justify-start gap-x-3 border-t border-gray-100 pt-3">
          <span class="text-sm text-gray-500">
            {{ isArabic() ? "الكمية" : "Quantity" }}
          </span>

          <span class="textTabsColor text-lg font-semibold">
            {{ bundleQuantity() }}
          </span>
        </div>
      }
    </div>
  </div>
</div>
